import type { ReactNode } from "react";
import {
  ControlPresentationContext,
  type ControlPresentation,
} from "./Internal/ControlPresentationContext";

/**
 * Sets the control presentation for a subtree — typically one form or flow.
 * Controls read this to choose between the dense boxed look (the default) and
 * the spacious underline look. Wrap the low-density customer flows — quote /
 * booking checkout, login / sign up — in
 * `<ControlPresentationProvider presentation="underlined">`; everything else
 * (admin / dashboard) stays boxed by default.
 */
export function ControlPresentationProvider({
  presentation,
  children,
}: {
  presentation: ControlPresentation;
  children: ReactNode;
}) {
  return (
    <ControlPresentationContext.Provider value={presentation}>
      {children}
    </ControlPresentationContext.Provider>
  );
}
